import * as React from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

import { cn } from '~/util';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = React.forwardRef<
    React.ElementRef<typeof CollapsiblePrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Trigger>
>(({ className, children, ...props }, ref) => {
    return (
        <CollapsiblePrimitive.Trigger
            ref={ref}
            className={cn(
                'flex w-fit items-center cursor-pointer! rounded-sm m-1 text-sm font-medium transition-all',
                className,
            )}
            {...props}
        >
            {children}
        </CollapsiblePrimitive.Trigger>
    );
});
CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName;

const CollapsibleContent = React.forwardRef<
    React.ElementRef<typeof CollapsiblePrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content> & {
        contentClassName?: string;
    }
>(({ className, contentClassName, children, ...props }, ref) => (
    <CollapsiblePrimitive.Content
        ref={ref}
        className={cn('overflow-hidden', className)}
        {...props}
    >
        <div className={cn('p-2', contentClassName)}>{children}</div>
    </CollapsiblePrimitive.Content>
));
CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
